import {Env} from '@autocut/utils/currentEnv.utils';

const AUTOCUT_CONSTANTS = {
  [Env.Development]: {
    JULY_ADDRESS: 'https://july-api-staging.onrender.com',
    GTM_ID: 'GTM-NLNML5QZ',
    JULY_API_KEY: 'Chnayfj&oX2&J#3388EaBG3E2J%$gZ&F',
    JULY_SECRET_KEY: 'kUcvzoXWTh%rVgs@Ne!cUP$Cm9Dke%Y3',
  },
  [Env.Production]: {
    JULY_ADDRESS: 'https://july.autocut.fr',
    GTM_ID: 'GTM-MLZ5MM4T',
    JULY_API_KEY:
      '*K!jGbhA7J8PkC9p&jPb2Dbm3Va@KVmxXr6vWfzm2SRgXCxE8ksPm@FFJG47#cXL',
    JULY_SECRET_KEY: 'kUcvzoXWTh%rVgs@Ne!cUP$Cm9Dke%Y3',
  },
  [Env.Staging]: {
    JULY_ADDRESS: 'https://staging.july.autocut.fr',
    GTM_ID: 'GTM-NLNML5QZ',
    JULY_API_KEY: 'Chnayfj&oX2&J#3388EaBG3E2J%$gZ&F',
    JULY_SECRET_KEY: 'kUcvzoXWTh%rVgs@Ne!cUP$Cm9Dke%Y3',
  },
} satisfies {
  [key in Env]: any;
};

export {AUTOCUT_CONSTANTS};
